import { render, staticRenderFns } from "./wikisearch.vue?vue&type=template&id=18f3ec1c&scoped=true"
import script from "./wikisearch.vue?vue&type=script&lang=js"
export * from "./wikisearch.vue?vue&type=script&lang=js"
import style0 from "./wikisearch.vue?vue&type=style&index=0&id=18f3ec1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3ec1c",
  null
  
)

export default component.exports